import './styles.scss';

import Checkbox from '@mui/material/Checkbox';
import Switch from '@mui/material/Switch';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useCallback, useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { isMobile } from 'react-device-detect';
import { ExternalLink as ExternalLinkIcon } from 'react-feather';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from '@/components/common/breadcrumb.component';
import DebounceSearchBar from '@/components/debounce-search-bar';
import Icon from '@/components/icon';
import ModalDialog from '@/components/modal-dialog';
import NoDataIndicator from '@/components/no-data-indicator';
import StandalonePagination from '@/components/pagination/standalone';
import RowMoreOptions from '@/components/table/row-more-options';
import TableLoader from '@/components/table-loader';
import { Constants } from '@/constants';
import {
  getAllVenues,
  postVenue,
  putVenue,
  searchVenues,
} from '@/redux/actions/venue.actions';

import VenueCsvImport from './venue-csv-import';

const hashids = new Hashids('', 12);

const defaultSorted = [
  {
    dataField: 'name',
    order: 'asc',
  },
];

const cellEditProps = {
  mode: 'dbclick',
};

const date = new Date();
let dateMonth = date.getMonth() + 1;
let dateDay = date.getDate();
let dateDayNext = date.getDate() + 1;

if (dateMonth < 10) {
  dateMonth = `0${dateMonth}`;
}
if (dateDay < 10) {
  dateDay = `0${dateDay}`;
}
if (dateDayNext < 10) {
  dateDayNext = `0${dateDayNext}`;
}
const dateToday = `${date.getFullYear()}-${dateMonth}-${dateDay}`;

const defaults = {
  selectedId: null,
  selectedName: '',
  selectedDescription: null,
  selectedWebsite: '',
  selectedAddress: null,
  selectedPhone: '',
  selectedEmail: '',
  selectedYelpId: '',
  selectedFoursquareId: '',
  selectedGoogleId: '',
  selectedTwitterId: '',
  selectedFacebookId: '',
  selectedInstagramId: '',
  selectedCanBuy: '',
  selectedCanBuyOnline: '',
  selectedCanSmoke: '',
  selectedTags: '',
  selectedVenueImages: [],
  selectedImagesToAttach: [],
  selectedImagesToRemove: [],
  selectedForceMerge: false,
  selectedHoursType: 'custom',
  selectedMonday: false,
  selectedTuesday: false,
  selectedWednesday: false,
  selectedThursday: false,
  selectedFriday: false,
  selectedSaturday: false,
  selectedSunday: false,
  selectedHours: [{}, {}, {}, {}, {}, {}, {}],
  selectedEvent: {},
  selectedStartDate: `${dateToday}T12:00:00`,
  selectedEndDate: `${dateToday}T12:00:00`,
  active: false,
  dialogModal: {
    show: false,
    title: '',
    text: '',
  },
  mergeVenue: '',
  merging: false,
  venueLogo: undefined,
  venueCoverImage: undefined,
  virtualTourEmbedCode: null,
};

const VenueTable = (props) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    venues: [],
    page: 1,
    sizePerPage: 30,
    showPagePickerModal: false,
    showVenueModal: false,
    showMergeModal: false,
    showOwnerModal: false,
    showHoursModal: false,
    showEventsModal: false,
    showImageUrlModal: false,
    showFilterDrawer: false,
    showMissingPrice: false,
    showPossibleDuplicates: false,
    selectedCity: null,
    selectedState: null,
    selectedCountry: null,
    message: { type: 'info', show: false, title: '', text: '' },
    ...defaults,
  });

  useEffect(() => {
    if (props.VenueManager.data) {
      setState((prev) => ({ ...prev, venues: props.VenueManager.data }));
    }
  }, [props.VenueManager.data]);

  const updateState = (newState: any) =>
    setState((prev: any) => ({ ...prev, ...newState }));

  const handleRowChange = (updatedVenue) => {
    const { venues } = state;
    console.log(`Updating venue for ${updatedVenue.id}...`);
    const updatedVenues = venues.map((venue) => {
      if (venue.id === updatedVenue.id) {
        return { ...venue, ...updatedVenue };
      }
      return venue;
    });
    updateState({ venues: updatedVenues });
  };

  // TODO Use for merge and delete actions
  const handleRowDelete = (deletedVenue) => {
    const { venues } = state;
    console.log(`Removing venue for ${deletedVenue.id}...`);
    console.log(deletedVenue);
    let i = venues.length;
    while (i--) {
      const venue = venues[i];
      if (venue.id === deletedVenue.id) {
        venues.splice(i, 1);
      }
    }
    updateState({ venues });
  };

  const handleTableChange = useCallback(
    (type, { page, sizePerPage, searchText }) => {
      const {
        selectedCity,
        selectedState,
        selectedCountry,
        showPossibleDuplicates,
      } = state;
      const filters = showPossibleDuplicates ? { only_duplicates: true } : {};
      props.getAllVenues(page, sizePerPage, searchText, {
        city: selectedCity ? selectedCity.label : null,
        state: selectedState ? selectedState.value : null,
        country: selectedCountry ? selectedCountry.label : null,
        ...filters,
      });
      // Save the table change parameters
      setState((prev) => ({
        ...prev,
        tableChangeType: type,
        page,
        sizePerPage,
        searchText,
      }));
    },
    [state, props]
  );

  const imageFormatter = (imageUrl) => {
    if (imageUrl) {
      console.log('Image formatter content:', imageUrl);
      return (
        <div className="circle-thumbnail">
          <div className="react-fancybox">
            <div className="thumbnail thumbnail-sm">
              <img alt="" src={imageUrl} />
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const checkBoxFormatter = (checked) => (
    <div className="checkbox checkbox-secondary">
      <Checkbox
        name="checkbox"
        checked={checked}
        sx={{
          color: '#cccccc',
          '&.Mui-checked': {
            color: '#d3a966',
          },
        }}
      />
    </div>
  );

  const activeFormatter = (active, venue) => {
    console.log('Updating active switch state...');
    return (
      <span>
        <Switch
          checked={active}
          onChange={(e) => {
            venue.active = e.target.checked;
            putVenue(venue).then((updatedVenue) => {
              handleRowChange(updatedVenue);
            });
          }}
          color="secondary"
        />
      </span>
    );
  };

  const syncTowerData = (venue) => {
    ModalDialog.show({
      title: 'Under Development',
      type: 'info',
      message: "This feature isn't available yet.",
      buttons: [
        {
          label: 'Dismiss',
          onClick: () => {
            ModalDialog.close();
          },
        },
      ],
    });
  };

  const syncTowerImages = (venue) => {
    // TODO Loading indicator?
    console.log(`Syncing images for ${venue.name}`);
    axios
      .post(`${Constants.apiPath}/venues/sync/${venue.id}/images`)
      .then(() => {
        ModalDialog.show({
          title: 'Success!',
          type: 'success',
          message: 'The images have been successfully updated.',
          buttons: [
            {
              label: 'Dismiss',
              onClick: () => {
                ModalDialog.close();
              },
            },
          ],
        });
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.status) {
          ModalDialog.show({
            title: 'No Images',
            type: 'info',
            message:
              'Unable to get images for this venue. This usually means there either are no owner-added images available or the Google Place ID is not set.',
            buttons: [
              {
                label: 'Dismiss',
                onClick: () => {
                  ModalDialog.close();
                },
              },
            ],
          });
        } else {
          ModalDialog.show({
            title: 'Uh oh!',
            type: 'error',
            message:
              'Something went wrong. Please try again later or check the logs.',
            buttons: [
              {
                label: 'Dismiss',
                onClick: () => {
                  ModalDialog.close();
                },
              },
            ],
          });
        }
      });
  };

  const actionDropdown = (index, venue) => (
    <RowMoreOptions
      row={index}
      items={[
        {
          type: 'MenuItem',
          onClick: () => {
            // onOpenModal('claim', venue)
            alert('Coming soon!');
          },
          title: 'Claim profile',
        },
        {
          type: 'Divider',
        },
        {
          type: 'MenuItem',
          onClick: () => syncTowerData(venue),
          title: 'Sync Google Data',
        },
        {
          type: 'MenuItem',
          onClick: () => syncTowerImages(venue),
          title: 'Sync Google Images',
        },
        {
          type: 'Divider',
        },
        {
          type: 'MenuItem',
          onClick: () => {
            // onOpenModal('merge', venue);
            alert('Coming back soon!');
          },
          title: 'Merge',
        },
        {
          type: 'MenuItem',
          onClick: () => {
            ModalDialog.show({
              type: 'warning',
              title: 'Delete Venue?',
              message:
                'This will delete the venue and all related info and cannot be undone. Note: If users have any checkins associated with this venue, this will return an error. If that happens, you will need to merge the venue instead.',
              buttons: [
                {
                  label: 'No, Cancel',
                  onClick: () => {
                    ModalDialog.close();
                  },
                },
                {
                  label: 'Yes, Delete',
                  color: 'danger',
                  onClick: () => {
                    // deleteVenue();
                  },
                },
              ],
            });
          },
          style: { color: 'red' },
          title: 'Delete',
        },
      ]}
      onShow={() => {
        // Hide the row buttons
        document
          .querySelector(`#dropdown-actions-${index}`)
          .classList.add('d-none');
      }}
    />
  );

  const editBtnFormatter = (cell, row, index) => (
    <div style={{ width: 68 }}>
      <div id={`dropdown-actions-${index}`} className="d-none">
        <Icon
          name="edit2"
          className="ml-1 mr-3"
          style={{
            cursor: 'pointer',
            display: 'inline',
            height: 18,
            width: 18,
          }}
          onClick={() => {
            const venue = row;
            navigate(
              `/venues/editor/${venue.hash_id || hashids.encode(venue.id)}`,
              { state: { venue } }
            );
          }}
        />
        {actionDropdown(index, row)}
      </div>
    </div>
  );

  const streetFormatter = (cell) => {
    if (cell) {
      return <span>{cell.address1}</span>;
    }
    return null;
  };

  const cityFormatter = (cell) => {
    if (cell) {
      return <span>{cell.city}</span>;
    }
    return null;
  };

  const yelpLinkFormatter = (cell) => {
    if (cell) {
      const href = `https://www.yelp.com/biz/${cell}`;
      return (
        <a href={href} target="_blank">
          <ExternalLinkIcon style={{ fontSize: 18 }} className="ml-2" />
        </a>
      );
    }
    return null;
  };

  const foursquareLinkFormatter = (cell) => {
    if (cell) {
      const href = `https://foursquare.com/v/${cell}`;
      return (
        <a href={href} target="_blank">
          <ExternalLinkIcon style={{ fontSize: 18 }} className="ml-2" />
        </a>
      );
    }
    return null;
  };

  const googleLinkFormatter = (cell) => {
    if (cell) {
      const href = `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${cell}`;
      return (
        <a href={href} target="_blank">
          <ExternalLinkIcon style={{ fontSize: 18 }} className="ml-2" />
        </a>
      );
    }
    return null;
  };

  const columns = [
    {
      dataField: 'active',
      text: 'Active',
      formatter: activeFormatter,
      sort: false,
    },
    {
      dataField: 'profile_image_url',
      text: 'Image',
      formatter: imageFormatter,
      sort: false,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'website',
      text: 'Website',
      sort: true,
    },
    {
      dataField: 'location',
      text: 'Street',
      formatter: streetFormatter,
      sort: true,
    },
    {
      dataField: 'location',
      text: 'City',
      formatter: cityFormatter,
      sort: true,
    },
    {
      dataField: 'can_buy',
      text: 'Can Buy',
      formatter: checkBoxFormatter,
      sort: true,
    },
    {
      dataField: 'can_smoke',
      text: 'Can Smoke',
      formatter: checkBoxFormatter,
      sort: true,
    },
    {
      dataField: 'can_buy_online',
      text: 'Can Buy Online',
      formatter: checkBoxFormatter,
      sort: true,
    },
    {
      dataField: 'yelp_id',
      text: 'Yelp',
      formatter: yelpLinkFormatter,
      sort: true,
    },
    {
      dataField: 'foursquare_id',
      text: 'Foursquare',
      formatter: foursquareLinkFormatter,
      sort: true,
    },
    {
      dataField: 'google_id',
      text: 'Google',
      formatter: googleLinkFormatter,
      sort: true,
    },
    {
      dataField: 'edit',
      text: '',
      formatter: editBtnFormatter,
      sort: true,
    },
  ];

  const rowEvents = {
    onMouseEnter: (e, row, index) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        .classList.remove('d-none');
    },
    onMouseLeave: (e, row, index) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        .classList.add('d-none');
    },
  };

  const pageButtonRenderer = ({ page: currentPage, active, onPageChange }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(currentPage);
    };
    const classname = active
      ? 'btn btn-secondary'
      : 'btn btn-outline-secondary';
    return (
      <li className="page-item pl-1" key={currentPage}>
        <a href="#" onClick={handleClick} className={classname}>
          {currentPage}
        </a>
      </li>
    );
  };

  return (
    <div>
      <SweetAlert
        show={state.message.show}
        type={state.message.type}
        title={state.message.title}
        onConfirm={() =>
          setState((prev) => ({
            ...prev,
            message: { show: false, title: '', text: '' },
          }))
        }
      >
        {state.message.text}
      </SweetAlert>

      <Breadcrumb title="Venue Manager" label="Manager" parent="Venues" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="mb-0">
              <div className="datatable-react">
                <PaginationProvider
                  pagination={paginationFactory({
                    pageButtonRenderer,
                    page: state.page,
                    sizePerPage: state.sizePerPage,
                    custom: true,
                    totalSize: state.venues.length,
                    showTotal: true,
                  })}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      <ToolkitProvider
                        keyField="id"
                        data={state.venues}
                        columns={columns}
                        search
                      >
                        {(toolkitprops) => (
                          <div>
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 8,
                                marginTop: 20,
                              }}
                            >
                              {isMobile && (
                                <DebounceSearchBar
                                  {...toolkitprops.searchProps}
                                  placeholder="Search cigars..."
                                  onChange={() => updateState({ page: 1 })}
                                  onSearch={(query) => {
                                    // INFO Since mobile doesn't use BootstrapTable, this needs managed manually
                                    updateState({ searchText: query });
                                  }}
                                />
                              )}
                              {!isMobile && (
                                <div style={{ flex: 1 }}>
                                  <DebounceSearchBar
                                    {...toolkitprops.searchProps}
                                    placeholder="Search cigars..."
                                    onChange={() => updateState({ page: 1 })}
                                  />
                                </div>
                              )}
                              <button
                                className="btn btn-secondary mr-2"
                                // onClick={() => onOpenModal('filter')}
                                style={
                                  isMobile
                                    ? {
                                        padding: '6px 14px',
                                      }
                                    : {}
                                }
                              >
                                {isMobile ? (
                                  <i className="icon icon-filter" />
                                ) : (
                                  'Filter'
                                )}
                              </button>
                              <VenueCsvImport
                                onImported={() =>
                                  handleTableChange('refresh', state)
                                }
                              />
                              <button
                                className="btn btn-primary"
                                onClick={() => navigate('/venues/editor/new')}
                              >
                                {isMobile ? (
                                  <i className="icon icon-plus" />
                                ) : (
                                  'Add Venue'
                                )}
                              </button>
                            </div>
                            <BootstrapTable
                              remote
                              keyField="id"
                              data={state.venues}
                              columns={columns}
                              defaultSorted={defaultSorted}
                              wrapperClasses="table-responsive"
                              rowEvents={rowEvents}
                              {...paginationTableProps}
                              cellEdit={cellEditFactory(cellEditProps)}
                              onTableChange={handleTableChange}
                              noDataIndication={() =>
                                !state.loading ? (
                                  <NoDataIndicator message="No venues found matching search query." />
                                ) : (
                                  <TableLoader />
                                )
                              }
                              {...toolkitprops.baseProps}
                            />
                            <PaginationTotalStandalone {...paginationProps} />
                            <div
                              style={{
                                width: 200,
                                display: 'inline-block',
                                float: 'right',
                              }}
                            />
                            <div style={{ display: 'flex', paddingBottom: 20 }}>
                              <div style={{ flex: 1 }}>
                                <StandalonePagination
                                  paginationProps={paginationProps}
                                />
                              </div>
                              <div>
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  )}
                </PaginationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ VenueManager }) => ({ VenueManager });

export default connect(mapStateToProps, {
  getAllVenues,
  searchVenues,
  postVenue,
  putVenue,
})(VenueTable);
